import { render, staticRenderFns } from "./table-footer-pagination.vue?vue&type=template&id=462dca37&scoped=true&"
import script from "./table-footer-pagination.vue?vue&type=script&lang=ts&"
export * from "./table-footer-pagination.vue?vue&type=script&lang=ts&"
import style0 from "./table-footer-pagination.vue?vue&type=style&index=0&id=462dca37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462dca37",
  null
  
)

export default component.exports